import { render, staticRenderFns } from "./berita.vue?vue&type=template&id=d62fb2de"
import script from "./berita.vue?vue&type=script&lang=js"
export * from "./berita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QIcon,QPagination,QDialog,QEditor,QFile,QCardActions,QImg,QSeparator,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QIcon,QPagination,QDialog,QEditor,QFile,QCardActions,QImg,QSeparator})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
